export interface SopformImage {
  id: number;
  sopformId: number | null;
  typeId: number | null;
  imageUrl: string | null;
  notes: string | null;
  dateCreated: string | null;
}

export enum SopformImageTypeEnum {
  DamageLeaks = 1,
  LightsSignalsBrakes = 2,
  SafetyEquipmentPpe = 3,
}
